import axios from "axios";
import { API_HOST } from "@/core/variables";
import { SceneTemplateCreate } from "@/model";
import { escapeCondition } from "@/util/stringUtil";


class TemplateRepository {
    create = async (scenarioId: string, template: SceneTemplateCreate) => {
        const response = await axios.post(
            `${API_HOST}/scenario/${scenarioId}/templates`,
            template
        );
        return response.data;
    };

    find = async (scenarioId: string, condition?: string) => {
        const searchCondition = escapeCondition(condition);

        const response = await axios.get(
            `${API_HOST}/scenario/${scenarioId}/templates`,
            {
                params: { condition: searchCondition }
            }
        );
        return response.data;
    };

    update = async (scenarioId: string, formData: FormData) => {
        const response = await axios.put(
            `${API_HOST}/scenario/${scenarioId}/templates`,
            formData,
            {
                headers: {
                    "content-type": "multipart/form-data"
                }
            }
        );
        return response.data;
    };

    delete = async (scenarioId: string, templateId: number) => {
        const response = await axios.delete(
            `${API_HOST}/scenario/${scenarioId}/templates/${templateId}`
        );
        return response.data;
    };
}

const templateRepository = new TemplateRepository();

export default templateRepository;
